import { Component } from "@angular/core";

@Component({
	templateUrl: "./constants.component.html"
})
export class ConstantsComponent { }
